'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegrationJsBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(IntegrationJsBox, _Component);

  function IntegrationJsBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IntegrationJsBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IntegrationJsBox.__proto__ || (0, _getPrototypeOf2.default)(IntegrationJsBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false,
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IntegrationJsBox, [{
    key: 'toggleOpen',
    value: function toggleOpen() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          focused = _state.focused,
          open = _state.open;
      var _props = this.props,
          errors = _props.errors,
          markup = _props.markup,
          polyglot = _props.polyglot,
          style = _props.style;


      var wrapperClasses = (0, _classnames2.default)({
        active: focused,
        'integration-js-box': true,
        'line-box': true,
        'has-error': errors,
        open: open
      });
      var inputClasses = (0, _classnames2.default)({
        inputs: true,
        open: open
      });

      return _react2.default.createElement(
        'div',
        { className: wrapperClasses },
        _react2.default.createElement(
          'label',
          null,
          polyglot.t('events.integrationJsBox.title')
        ),
        _react2.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'link', bsSize: 'small', className: 'toggle-button', onClick: this.toggleOpen.bind(this) },
          open ? polyglot.t('events.integrationJsBox.hide') : polyglot.t('events.integrationJsBox.show')
        ),
        _react2.default.createElement(
          'div',
          { className: inputClasses },
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label' },
              polyglot.t('events.integrationJsBox.markupLabel')
            ),
            _react2.default.createElement('textarea', { rows: '6', className: 'form-control', value: markup || '', onChange: this.props.onChangeMarkup })
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'label',
              { className: 'control-label' },
              polyglot.t('events.integrationJsBox.styleLabel')
            ),
            _react2.default.createElement('textarea', { rows: '6', className: 'form-control', value: style || '', onChange: this.props.onChangeStyle })
          )
        )
      );
    }
  }]);
  return IntegrationJsBox;
}(_react.Component), _class.propTypes = {
  errors: _propTypes2.default.any,
  markup: _propTypes2.default.string,
  onChangeMarkup: _propTypes2.default.func,
  onChangeStyle: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.string
}, _temp2);
exports.default = IntegrationJsBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/IntegrationJsBox.js
// module id = 2216
// module chunks = 0